module.exports = __webpack_public_path__ + "static/Greg-51406ac0349b555ea3474cbc8380e7b0.jpeg";